import RemoteComponent from './index.vue';
export default RemoteComponent;


// WEBPACK FOOTER //
// ./src/components/remote-component/index.js